/**
 * PNR Service
 * The PNR integration API
 *
 * The version of the OpenAPI document: master-7a801ca4-799560
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { CodeSuccessResponseDto } from '../model/codeSuccessResponseDto';
import { ConnectAuthDto } from '../model/connectAuthDto';
import { CreateCodeDto } from '../model/createCodeDto';
import { ErrorResponseDto } from '../model/errorResponseDto';
import { SuccessResponseDto } from '../model/successResponseDto';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class ConnectApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     * @param connectAuthDto 
     */
    public authApp(connectAuthDto: ConnectAuthDto, ): Observable<AxiosResponse<SuccessResponseDto>>;
    public authApp(connectAuthDto: ConnectAuthDto, ): Observable<any> {

        if (connectAuthDto === null || connectAuthDto === undefined) {
            throw new Error('Required parameter connectAuthDto was null or undefined when calling authApp.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.post<SuccessResponseDto>(`${this.basePath}/connect/auth`,
            connectAuthDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param createCodeDto 
     */
    public createAuthorizationCode(createCodeDto: CreateCodeDto, ): Observable<AxiosResponse<CodeSuccessResponseDto>>;
    public createAuthorizationCode(createCodeDto: CreateCodeDto, ): Observable<any> {

        if (createCodeDto === null || createCodeDto === undefined) {
            throw new Error('Required parameter createCodeDto was null or undefined when calling createAuthorizationCode.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.put<CodeSuccessResponseDto>(`${this.basePath}/connect/code`,
            createCodeDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param provider Provider identifier (string)
     * @param organization Organization identifier
     */
    public getAuthorizationCode(provider: string, organization: string, ): Observable<AxiosResponse<CodeSuccessResponseDto>>;
    public getAuthorizationCode(provider: string, organization: string, ): Observable<any> {

        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling getAuthorizationCode.');
        }

        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling getAuthorizationCode.');
        }

        let queryParameters = new URLSearchParams();
        if (provider !== undefined && provider !== null) {
            queryParameters.append('provider', <any>provider);
        }
        if (organization !== undefined && organization !== null) {
            queryParameters.append('organization', <any>organization);
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<CodeSuccessResponseDto>(`${this.basePath}/connect/code`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param provider Provider identifier (string)
     * @param organizationId Organization identifier (UUID)
     */
    public revokeAuthorizationCode(provider: string, organizationId: string, ): Observable<AxiosResponse<SuccessResponseDto>>;
    public revokeAuthorizationCode(provider: string, organizationId: string, ): Observable<any> {

        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling revokeAuthorizationCode.');
        }

        if (organizationId === null || organizationId === undefined) {
            throw new Error('Required parameter organizationId was null or undefined when calling revokeAuthorizationCode.');
        }

        let queryParameters = new URLSearchParams();
        if (provider !== undefined && provider !== null) {
            queryParameters.append('provider', <any>provider);
        }
        if (organizationId !== undefined && organizationId !== null) {
            queryParameters.append('organizationId', <any>organizationId);
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<SuccessResponseDto>(`${this.basePath}/connect/revoke`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
